import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { RegisterUserProperties } from './RegisterProperties';
import { CitiesWithManagerCode } from '../Models/Countries';
@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.baseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  RegisterGetAlls(userId:string): Observable<RegisterUserProperties[]> {
    return this.http.get<RegisterUserProperties[]>(this.baseUrl + '/Register/RegisterGetAlls/'+ userId).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }
  RegisterGetById(registerId: number): Observable<RegisterUserProperties> {
    return this.http.get<RegisterUserProperties>(this.baseUrl + '/Register/RegisterGetById/' + registerId).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }
  CreateRegister(newobj: FormData): Observable<boolean> {
    return this.http.post<boolean>(
      this.baseUrl + '/Register/CreateRegister',
      newobj
    ).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }
  approveOrRejectAgent(model: { RegisterId: number; isApproved: boolean }): Observable<boolean> {
    return this.http.post<boolean>(
      this.baseUrl + '/Register/approve-or-reject-agent',
      model
    ).pipe(
      map((data: boolean) => data),
      catchError(error => {
        return throwError(error);
      })
    );
  }
  downloadUserFiles(registerId: number): Observable<Blob> {
    return this.http.get(
      `${this.baseUrl}/Register/download-user-files/${registerId}`,
      {
        responseType: 'blob'
      }
    ).pipe(
      catchError(error => {
        return throwError(error);
      })
    );
  }
  downloadCompanyDetails(): Observable<Blob> {
    return this.http.get(
      `${this.baseUrl}/Register/download-company-agreements`,
      {
        responseType: 'blob'
      }
    ).pipe(
      catchError(error => {
        return throwError(error);
      })
    );
  }



  //getCities(): Observable<citiesWithManagerCode[]> {
  //  return this.http.get<citiesWithManagerCode[]>(this.baseUrl + '/Register/GetAllCitiesWithManagerCode')
  //    .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  //}
  //getCities(): Observable<citiesWithManagerCode[]> {
  //  return this.http.get<citiesWithManagerCode[]>(
  //    this.baseUrl + '/Register/GetAllCitiesWithManagerCode'
  //  ).pipe(
  //    map((data: any) => data),
  //    catchError(error => throwError(error))
  //  );
  //}
  getCities(): Observable<CitiesWithManagerCode[]> {
    console.log("Base URL:", this.baseUrl);
    return this.http.get<CitiesWithManagerCode[]>(this.baseUrl + '/Register/GetAllCitiesWithManagerCode').pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }

}
